// extracted by mini-css-extract-plugin
module.exports = {"hero":"hero_hero__69x1n","image":"hero_image__Xz8fr","children":"hero_children__4wydG"};